import ChartGraph from "utils/Charts/ChartGraph/ChartGraph";
import { financialReportOption } from "./data";

const FinancialReports = () => {
	return (
		<div className="pt-1">
			<ChartGraph
				option={financialReportOption}
				styles={{
					height: "361px",
				}}
			/>
		</div>
	);
};

export default FinancialReports;
